import { AnyAction } from 'redux'
import { createSelector } from 'reselect'

const initialState: State.AttributeNameByFilterNameState = {}

export function reducer(state: State.AttributeNameByFilterNameState = initialState, action: AnyAction): State.AttributeNameByFilterNameState {
  switch (action.type) {
    default:
      return state
  }
}

export const attributeNameByFilterNameSelector = createSelector(
  (state: State.GlobalState) => state.attributeNameByFilterName,
  (attributeNameByFilterName) => (filterName: string) => attributeNameByFilterName[filterName],
)
